import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
	faArrowRightLong,
	faBars,
	faCalendarDays,
	faChevronDown,
	faChevronCircleLeft,
	faChevronCircleRight,
	faEnvelope,
	faPhone,
	faChevronUp,
	faGlobe,
	faTimes,
} from '@fortawesome/pro-light-svg-icons';

import {
	faFacebook,
	faInstagram,
	faLinkedin,
	faPinterest,
	faSoundcloud,
	faSpotify,
	faTiktok,
	faTwitter,
	faWhatsapp,
	faXTwitter,
	faYoutube,
} from '@fortawesome/free-brands-svg-icons';

import {
	faArrows,
	faBedAlt,
	faBellConcierge,
	faCheck,
	faEuroSign,
	faMinus,
	faPlay,
	faPlus,
	faRulerCombined,
	faSearch,
	faStar,
	faStars,
	faQuoteLeft,
	faStarHalf,
	faUsers,
} from '@fortawesome/pro-solid-svg-icons';

// This is important, we are going to let Nuxt.js worry about the CSS
config.autoAddCss = false;

library.add(
	faArrows,
	faArrowRightLong,
	faBars,
	faBedAlt,
	faBellConcierge,
	faCheck,
	faChevronCircleLeft,
	faChevronCircleRight,
	faChevronUp,
	faChevronDown,
	faCalendarDays,
	faEnvelope,
	faEuroSign,
	faGlobe,
	faQuoteLeft,
	faFacebook,
	faInstagram,
	faLinkedin,
	faMinus,
	faPinterest,
	faPhone,
	faPlay,
	faPlus,
	faRulerCombined,
	faSearch,
	faSoundcloud,
	faSpotify,
	faStars,
	faTiktok,
	faTimes,
	faTwitter,
	faUsers,
	faWhatsapp,
	faYoutube,
	faStar,
	faStarHalf,
	faXTwitter,
);

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.component('font-awesome-icon', FontAwesomeIcon, {});
});
